module.exports = __webpack_public_path__ + "c0d3c94cd6112550c51d7d1ed13b9da1.eot";


//////////////////
// WEBPACK FOOTER
// /~/react-notifications/lib/fonts/notification.eot?s3g3t9
// module id = 886
// module chunks = 27